var _rect, _rect2, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSharedSnippets = function SvgSharedSnippets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.773,
    y: 0.78,
    width: 22.44,
    height: 22.44,
    rx: 6,
    fill: "url(#shared-snippets_svg__a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.773,
    y: 0.78,
    width: 22.44,
    height: 22.44,
    rx: 6,
    fill: "url(#shared-snippets_svg__b)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.586 5.836a.75.75 0 1 0 0 1.5h5.672a.75.75 0 0 0 0-1.5H6.586Zm9.281 0a.75.75 0 0 0 0 1.5h1.547a.75.75 0 0 0 0-1.5h-1.547Zm-3.844 11.578a.75.75 0 0 1 .75-.75h4.641a.75.75 0 1 1 0 1.5h-4.64a.75.75 0 0 1-.75-.75Zm-5.437-.75a.75.75 0 1 0 0 1.5h2.578a.75.75 0 0 0 0-1.5H6.586Zm-.75-2.86a.75.75 0 0 1 .75-.75h4.64a.75.75 0 0 1 0 1.5h-4.64a.75.75 0 0 1-.75-.75Zm9-.75a.75.75 0 0 0 0 1.5h2.578a.75.75 0 0 0 0-1.5h-2.578Zm-9-2.859a.75.75 0 0 1 .75-.75h1.547a.75.75 0 1 1 0 1.5H6.586a.75.75 0 0 1-.75-.75Zm5.906-.75a.75.75 0 0 0 0 1.5h5.672a.75.75 0 0 0 0-1.5h-5.672Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shared-snippets_svg__a",
    x1: 0.773,
    y1: 0.78,
    x2: 23.212,
    y2: 23.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shared-snippets_svg__b",
    x1: 0.773,
    y1: 0.78,
    x2: 23.212,
    y2: 23.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5764F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A339A"
  })))));
};

export default SvgSharedSnippets;